import React, { lazy, Suspense } from "react";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Root from "../pages/Root";
import HomePage from "../../src/pages/home/homePage";
import { useUser } from "../contexts/userContext";
import { Spinner } from "react-bootstrap";
import { SplashLoader } from "../components/common/SplashLoader";
import { useFacebookPageView } from "../hooks/useFacebbokPageView";
import UpdateListPage from "../pages/updates/UpdateListPage";
import UpdateDetailPage from "../pages/updates/UpdateDetailPage";
const LoginPage = lazy(() =>
  import("../../src/pages/login/loginPage").then((m) => ({
    default: m.LoginPage,
  }))
);
const RegisterPage = lazy(() => import("../pages/registration/registrationPage"));
const PickupForm = lazy(
  () => import("../pages/handle-Bulk-Pickups/handleBulkPickupPage")
);
const VerifyOtp = lazy(() => import("../pages/verify-otp/verifyOtpPage"));
const AboutUsPage = lazy(() => import("../pages/about/aboutUsPage"));
const TermsOfUsePage = lazy(
  () => import("../pages/terms&conditions/termsOfUsePage")
);
const ShipmentPolicyPage = lazy(
  () => import("../pages/terms&conditions/shipmentPolicyPage")
);
const PrivacyAndCookiesPage = lazy(
  () => import("../pages/terms&conditions/privacy&CookiesPage")
);
const CancellationPolicyPage = lazy(
  () => import("../pages/terms&conditions/cancellationPolicyPage")
);
const SellNowPage = lazy(() => import("../pages/sell-now/sellNowPage"));
const CartPage = lazy(() => import("../pages/cart/cartPage"));
const NewCartPage = lazy(() =>
  import("../pages/cart/cartPage_dev").then((module) => ({
    default: module.CartPage,
  }))
);
const AddressPage = lazy(() => import("../pages/address/addressPage"));
const ProfilePage = lazy(() => import("../pages/UserProfile/userProfileUpdatePage"));
const UpdateAddressPage = lazy(() => import("../pages/address/upadteAddressPage"));
const FaqPage = lazy(() => import("../pages/faq/faqPage"));
const ContactUsPage = lazy(() => import("../pages/contactUs/contactUs"));
const ProductDetailPage = lazy(
  () => import("../pages/sell-now/productDetailPage")
);
const ExchangeHomePage = lazy(
  () => import("../exchangePages/home/homePage")
);
const ProductFormPage = lazy(
  () => import("../exchangePages/productdetails/productform")
);
const PersonalInfoFormPage = lazy(
  () => import("../exchangePages/personalDetails/personalDetailPage")
);
const VerifyRegistrationOtp = lazy(
  () => import("../exchangePages/verify-otp/verifyRegistrationOtpPage")
);
const SummaryPage = lazy(
  () => import("../exchangePages/exchange-summary/exchangeSummaryPage")
);
const ThankyouPage = lazy(
  () => import("../exchangePages/thanks-page/thankyouPage")
);
const VerifyExchangeOtp = lazy(
  () => import("../exchangePages/verify-otp/verifyOtpPage")
);
const NotFoundPage = lazy(() => import("../pages/notFound/notFoundPage"));
const OrderThankyouPage = lazy(
  () => import("../pages/orderSummary/orderThankYouPage")
);
const ExchangeRoot = lazy(
  () => import("../exchangePages/ExchangeRoot/ExchangeRoot")
);
const BlogList = lazy(() => import("../pages/blog/blog_list/BlogList"));
const BlogDetail = lazy(() => import("../pages/blog/blog_detail/BlogDetail"));
const ExchangeCloneHomePage = lazy(
  () => import("../exchangePages copy/home/homePage")
);
const LoginClonePage = lazy(
  () => import("../exchangePages copy/login/loginPage")
);
const ProductCloneFormPage = lazy(
  () => import("../exchangePages copy/productdetails/productform")
);
const PersonalInfoCloneFormPage = lazy(
  () => import("../exchangePages copy/personalDetails/personalDetailPage")
);
const VerifyExchangeCloneOtp = lazy(
  () => import("../exchangePages copy/verify-otp/verifyOtpPage")
);
const ThankyouClonePage = lazy(
  () => import("../exchangePages copy/thanks-page/thankyouPage")
);
const SummaryyPage = lazy(
  () => import("../exchangePages copy/exchange-summary/exchangeSummaryPage")
);
const CouponsPage = lazy(() => import("../pages/coupons/couponsPage"));
const ExchangeProgramRoot = lazy(
  () => import("../genericExchangeJourney/ExchangeGenericRoot/ExchangeProgram")
);
const GenericExchangeProgramHomePage = lazy(
  () => import("../genericExchangeJourney/home/homePage")
);
const GenericExchangeProductFormPage = lazy(
  () => import("../genericExchangeJourney/productdetails/productform")
);
const GenericPersonalInfoProgramFormPage = lazy(
  () =>
    import("../genericExchangeJourney/personalDetails/personalDetailPage")
);
const GenericVerifyExchangeProgramOtp = lazy(
  () => import("../genericExchangeJourney/verify-otp/verifyOtpPage")
);
const GerericExchangeProgramSummaryPage = lazy(
  () => import("../genericExchangeJourney/exchange-summary/exchangeSummaryPage")
);
const GenericExchangeProgramThankyouPage = lazy(
  () => import("../genericExchangeJourney/thanks-page/thankyouPage")
);
const ProductSelectionPage_Dev = lazy(() =>
  import("../pages/sell-now/ProductSelectionPage_Dev").then((m) => ({
    default: m.ProductSelectionPage_Dev,
  }))
);
const OrderSummaryPageDev = lazy(
  () => import("../pages/orderSummary/orderSummary_dev")
);
// import ReferralsList from './pages/referrals/referralsPage';



const ProtectedRoute: React.FC<{ element: JSX.Element }> = ({ element }) => {
  const { isAuthorized } = useUser();

  if (isAuthorized) {
    return element;
  }

  return <Navigate to="/sell-used-appliances" replace />;
};




export const Router: React.FC = () => {
  const location = useLocation();
  useFacebookPageView()
  return (
    <Suspense fallback={<SplashLoader />} >
      <AnimatePresence mode="wait">
        <Routes key={location.pathname} location={location}>
          <Route path="/" element={<Root />}>
            <Route index path="/" element={<HomePage />} />

            <Route path="/:appliance" element={<ProductSelectionPage_Dev />} />
            <Route path="/sell-used-appliances" element={<SellNowPage />} />
            <Route path="/bulk-pickup" element={<PickupForm />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/order-submit" element={<OrderThankyouPage />} />
            <Route path="/terms-and-conditions" element={<TermsOfUsePage />} />
            <Route path="/shipping-policy" element={<ShipmentPolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyAndCookiesPage />} />
            <Route
              path="/cancellation-policy"
              element={<CancellationPolicyPage />}
            />
            <Route path="/product-detail-same" element={<ProductDetailPage />} />
            <Route path="/sell-used/:category" element={<SellNowPage />} />
            <Route path="/cart/old/listing" element={<CartPage />} />
            <Route path="/cart/listing" element={<NewCartPage />} />
            <Route path="/address" element={<AddressPage />} />
            <Route
              path="/order-summary"
              element={<ProtectedRoute element={<OrderSummaryPageDev />} />}
            />
            <Route path="/profile" element={<ProtectedRoute element={<ProfilePage />} />} />
            <Route path="/my-coupons" element={<CouponsPage />} />
            <Route path="/update-address" element={<UpdateAddressPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route
              path="/verify-registration-otp"
              element={<VerifyRegistrationOtp />}
            />
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blogs/:post_slug" element={<BlogDetail />} />
            <Route path="/updates" element={<UpdateListPage />} />
          <Route path="/updates/:slug" element={<UpdateDetailPage />} />
          </Route>

          <Route path="/exchange" element={<ExchangeRoot />}>
            <Route
              index
              path="/exchange/program/:prog_id"
              element={<ExchangeHomePage />}
            />
            <Route path="/exchange/product-form" element={<ProductFormPage />} />
            <Route
              path="/exchange/personalInfoForm"
              element={<PersonalInfoFormPage />}
            />
            <Route path="/exchange/verify-otp" element={<VerifyExchangeOtp />} />
            <Route path="/exchange/ordersummary" element={<SummaryPage />} />
            <Route
              path="/exchange/programechangesubmit"
              element={<ThankyouPage />}
            />

            <Route
              path="/exchange/programs/blue-star/:prog_id"
              element={<ExchangeCloneHomePage />}
            />
            <Route
              path="/exchange/blue-star/login"
              element={<LoginClonePage />}
            />
            <Route
              path="/exchange/blue-star/product-form"
              element={<ProductCloneFormPage />}
            />
            <Route
              path="/exchange/blue-star/personalInfoForm"
              element={<PersonalInfoCloneFormPage />}
            />
            <Route
              path="/exchange/blue-star/verify-otp"
              element={<VerifyExchangeCloneOtp />}
            />
            <Route
              path="/exchange/blue-star/verify-registration-otp"
              element={<VerifyExchangeCloneOtp />}
            />
            <Route
              path="/exchange/blue-star/ordersummary"
              element={<SummaryyPage />}
            />
            <Route
              path="/exchange/blue-star/programechangesubmit"
              element={<ThankyouClonePage />}
            />
          </Route>

          <Route path="/exchange-program" element={<ExchangeProgramRoot />}>
            <Route
              path="/exchange-program/:prog_id"
              element={<GenericExchangeProgramHomePage />}
            />

            <Route
              path="/exchange-program/product-form"
              element={<GenericExchangeProductFormPage />}
            />

            <Route
              path="/exchange-program/personalInfoForm"
              element={<GenericPersonalInfoProgramFormPage />}
            />

            <Route
              path="/exchange-program/verify-otp"
              element={<GenericVerifyExchangeProgramOtp />}
            />

            <Route
              path="/exchange-program/ordersummary"
              element={<GerericExchangeProgramSummaryPage />}
            />

            <Route
              path="/exchange-program/programechangesubmit"
              element={<GenericExchangeProgramThankyouPage />}
            />
          </Route>

          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />

          <Route path="*" element={<NotFoundPage />} />

        </Routes>
      </AnimatePresence>
    </Suspense>

  );
};
